import getStore from '../store/store';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { observer } from 'mobx-react-lite';
import { ActivityFeedOpx } from 'owa-activity-feed-opx';
import { FullComposeForm } from 'owa-calendar-full-compose-view';
import { CalendarReadingPane } from 'owa-calendar-reading-pane-view';
import { RelatedContentInsightsOpx } from 'owa-calendar-related-content-opx';
import { OwaAddGroupMemberV2Opx } from 'owa-group-addmembers-opx';
import { OwaCreateGroupV2Opx } from 'owa-group-create-opx';
import { OwaDiscoverGroupsOpx } from 'owa-group-discover-opx';
import { OwaEditGroupV2Opx } from 'owa-group-edit-opx';
import { DownloadMobileAppOpx } from 'owa-guided-setup-cards-opx';
import { InboxRulesOpx } from 'owa-inbox-rules-opx';
import loc from 'owa-localize';
import { LocationCardOpx } from 'owa-location-card-opx';
import { loadingLabel } from 'owa-locstrings/lib/strings/loadinglabel.locstring.json';
import { useClientStyles } from 'owa-react-hooks/lib/useClientStyles';
import { RoomPanelOpx } from 'owa-room-selection';
import { OpxYammerCard } from 'owa-yammer-thread';
import { QrConnectAppOpx } from 'owa-qrcode-opx';
import * as React from 'react';
import {
    getStore as getPopoutChildStore,
    PopoutLoadingView,
    PopoutChildState,
} from 'owa-popout-v2';

import stylesBase from './DeepLinkModule.scss';
import stylesMac from './DeepLinkModule.macoutlook.scss';
import stylesDesktop from './DeepLinkModule.outlookdesktop.scss';
const styles = { base: stylesBase, mac: stylesMac, desktop: stylesDesktop };

export default observer(function DeepLinkModule() {
    const { getClass } = useClientStyles(styles);

    React.useEffect(() => {
        // Override min-width on the global style after mount.
        document.body.style.minWidth = '0';
        document.body.style.margin = '0';
        document.body.style.overflowY = 'hidden';
    }, []);

    return (
        <ThemeProvider className={getClass('contentRoot')}>{renderContent(getClass)}</ThemeProvider>
    );
});

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7051 (51,35): Parameter has a name but no type. Did you mean 'arg0: string'? ...
// @ts-expect-error
function renderContent(getClass: (string) => string | undefined) {
    const { displayedView, formId } = getStore();
    const { state } = getPopoutChildStore();
    if (state != PopoutChildState.Ready) {
        // If pop out is not ready, then show loading view
        return (
            <div className={getClass('deeplinkView')}>
                <PopoutLoadingView loadingString={loc(loadingLabel)} />
            </div>
        );
    }
    switch (displayedView) {
        case 'Read':
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (67,33): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            return <CalendarReadingPane formId={formId} />;
        case 'Compose':
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (72,37): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            return <FullComposeForm formId={formId} />;
        case 'RoomPanel':
            return <RoomPanelOpx />;
        case 'MeetingInsights':
            return <RelatedContentInsightsOpx />;
        case 'LocationCard':
            return <LocationCardOpx />;
        case 'CreateGroup':
            return <OwaCreateGroupV2Opx />;
        case 'AddMembers':
            return <OwaAddGroupMemberV2Opx />;
        case 'EditGroup':
            return <OwaEditGroupV2Opx />;
        case 'DiscoverGroup':
            return <OwaDiscoverGroupsOpx />;
        case 'InboxRules':
            return <InboxRulesOpx />;
        case 'DownloadMobile':
            return <DownloadMobileAppOpx />;
        case 'ActivityFeed':
            return <ActivityFeedOpx />;
        case 'Yammer':
            return <OpxYammerCard />;
        case 'QrConnect':
            return <QrConnectAppOpx />;
    }
    return <div />;
}
